import Carousel from '../carousel';

class GalleryCarousel extends Carousel {
  public isInstant: boolean;

  constructor(selector: any = '.js-product-detail-images-carousel', settings: object = {}) {
    const SPEED = 800;

    const el: HTMLElement | null = document.querySelector(selector);
    const pagination: HTMLElement | null | undefined = el?.parentElement?.querySelector('.o-product-detail-images__pagination');

    if (!el) return

    const isInstant = el.classList.contains('instant');

    super(el, {
      ...settings,
      speed: isInstant ? 0 : SPEED,
      grabCursor: !isInstant,
      spaceBetween: 0,
      loop: !isInstant,
      watchOverflow: true,
      autoHeight: true,
      pagination:
        isInstant ? {
            enabled: false,
        } : {
          el: pagination,
          type: 'bullets',
          clickable: true,
        },
      on: {
        afterInit: (swiper: any) => {
          if (swiper.slides.length - 2 <= 1 || isInstant) {
            swiper.autoplay.stop();
            swiper.unsetGrabCursor();
            swiper.params.grabCursor = false;
            el?.classList.add('swiper-no-swiping');
          }
        },
      }
    })

    this.isInstant = isInstant;
  }

  init() {
    super.init();
  }

  getInstance() {
    return this.carousel;
  }

  switchToVariant(id: String|Number) {
    const slides = Array.from(this.carousel.slides) as HTMLElement[];
    const index = slides.findIndex((slide) =>  slide.dataset.variant === id.toString());

    if (index === -1) return

    this.carousel.slideTo(index, 0);
  }
}

export default GalleryCarousel;
